import { useEffect } from 'react';
import { Link } from 'react-router-dom';

import { PATH } from '../widget-lib/path-routes';

export type AuthRequiredModalProps = {
  open: boolean;
  onClose: () => void;
  /** Query string с key/kid/sig и т.д., тот же что у страницы */
  querySuffix: string;
  /** Куда вернуться после входа (`state.from`) */
  returnTo: string;
  title?: string;
  description?: string;
};

/**
 * Модальное окно: для записи или оплаты нужна авторизация.
 */
export function AuthRequiredModal({
  open,
  onClose,
  querySuffix,
  returnTo,
  title = 'Нужен вход',
  description = 'Чтобы продолжить, войдите в аккаунт или зарегистрируйтесь.'
}: AuthRequiredModalProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/55 p-4"
      role="presentation"
      onClick={onClose}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="auth-required-modal-title"
        className="w-full max-w-md rounded-sm border border-[var(--border)] bg-[var(--bg-elevated)] p-6 shadow-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="auth-required-modal-title" className="text-lg font-semibold text-[var(--text)]">
          {title}
        </h2>
        <p className="mt-2 text-sm text-[var(--text-muted)]">{description}</p>
        <div className="mt-6 flex justify-end">
          <Link
            to={`${PATH.signIn}${querySuffix}`}
            state={{ from: returnTo }}
            className="inline-flex h-9 items-center justify-center rounded-sm bg-[var(--btn-primary-bg)] px-3.5 text-[13px] font-medium text-[var(--btn-primary-fg)] transition-colors hover:bg-[var(--btn-primary-bg-hover)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--focus-ring)]"
          >
            Войти
          </Link>
        </div>
      </div>
    </div>
  );
}
